import { Component, signal, computed, inject } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from './core/services/auth.service';
import { UserRole } from './core/models/user.model';
import { BreadcrumbTrackerService } from './core/services/breadcrumb-tracker.service';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
})
export class App {
  protected readonly authService = inject(AuthService);
  private readonly breadcrumbTracker = inject(BreadcrumbTrackerService);
  protected readonly title = 'Recrutamento Ético';
  protected readonly currentUser = this.authService.currentUser;
  protected readonly UserRole = UserRole;

  protected readonly isModerator = computed(() => {
    const user = this.currentUser();
    return (
      user &&
      (user.role === UserRole.MODERATOR || user.role === UserRole.ADMIN)
    );
  });

  protected readonly isAdmin = computed(() => {
    const user = this.currentUser();
    return user?.role === UserRole.ADMIN;
  });

  protected readonly userInitials = computed(() => {
    const email = this.currentUser()?.email?.trim().toLowerCase();
    if (!email) return 'U';
    const local = email.split('@')[0] || '';
    const parts = local.split(/[._-]+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return local.slice(0, 2).toUpperCase();
  });

  logout(): void {
    this.authService.logout();
  }
}
